import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import PropertyFinancial from './pages/PropertyFinancial';
import HealthWelfare from './pages/HealthWelfare';
import MentalCapacity from './pages/MentalCapacity';
import Fees from './pages/Fees';
import FAQs from './pages/FAQs';
import About from './pages/About';
import Contact from './pages/Contact';
import Legal from './pages/Legal';
import ClientForm from './pages/ClientForm';
import CourtOfProtection from './pages/CourtOfProtection';
import ThankYou from './pages/ThankYou';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <main className="page-top">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/lasting-power-of-attorney" element={<Home />} />
          <Route path="/property-financial-affairs-lpa" element={<PropertyFinancial />} />
          <Route path="/health-welfare-lpa" element={<HealthWelfare />} />
          <Route path="/mental-capacity-act-2005" element={<MentalCapacity />} />
          <Route path="/lpa-fees" element={<Fees />} />
          <Route path="/lasting-power-of-attorney-faqs" element={<FAQs />} />
          <Route path="/about-charles-lossos" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal/:page" element={<Legal />} />
          <Route path="/court-of-protection" element={<CourtOfProtection />} />
          <Route path="/client-form" element={<ClientForm />} />
          <Route path="/thank-you" element={<ThankYou />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
